import { Button, Img, Input, Text } from "components";
import { useTranslation } from "react-i18next";
import { DefaultMoney } from "./DefaultMoney";
import * as CUSTOM from "../../../../../../utils/helper/custom";

const Account = (props) => {
  const { setIsAddMoney, setPaymentData, paymentData } = props;
  const { t } = useTranslation();
  const moneyAaray = ["100", "200", "300", "400", "500"];

  return (
    <>
      <div className="relative flex flex-col w-full">
        {/* ── Amount input ── */}
        <div className="flex flex-col items-start justify-start w-full">
          <Text
            className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[var(--Blacks-300,#6D737E)] mb-1.5"
          >
            {t("amount")} *
          </Text>
          <div className="w-full">
            <Input
              className="w-full figma-input"
              value={paymentData?.amount}
              placeholder={t("writeCustomAmountHere")}
              onChange={(e) => {
                setPaymentData({
                  ...paymentData,
                  amount: CUSTOM.strFormat(e.target.value, "number|max:6"),
                  // keep step in sync so payment section stays active
                  step: 2,
                });
              }}
              startAdornment={
                <div className="flex items-center justify-center w-6 h-6 rounded-full mr-2 rtl:mr-0 rtl:ml-2 flex-shrink-0">
                  <Img src="images/amount.png" className="rounded-full" />
                </div>
              }
            />
          </div>

          {/* Quick-amount chips */}
          <div className="flex w-full gap-2.5 flex-wrap mt-3">
            {moneyAaray.map((items, index) => {
              const val = CUSTOM.replaceKeyValue(items, "+", "");
              return (
                <DefaultMoney
                  key={`money-1-${index}`}
                  label={items}
                  value={val}
                  onClick={(e) => {
                    setPaymentData({
                      ...paymentData,
                      amount: e.target.value,
                      step: 2,
                    });
                  }}
                  checked={items == "+" + paymentData?.amount}
                  name="default"
                  className="w-auto"
                  id={`money-1-${index}`}
                />
              );
            })}
          </div>
        </div>

        {/*
          ── COMMENTED: old step-1 proceed button + cancel ──
          {paymentData?.step == 1 ? (
            <div className="flex items-start justify-start xs:justify-center pt-[30px] gap-4 mb-[18px] xs:flex-wrap">
              <Button
                className="flex-1 max-w-[280px] xs:text-sm xs:whitespace-nowrap"
                size="md"
                variant="FillBlack"
                hover={true}
                hoverclass="bg-white-A700"
                onClick={(e) => {
                  setPaymentData({ ...paymentData, step: 2 });
                }}
                disabled={!paymentData?.amount || paymentData?.amount == 0}
              >
                {t("proceedToAdd")} ({t("sar")} {paymentData?.amount})
              </Button>
              <Button
                className="w-auto min-w-[92px] xs:text-sm"
                size="md"
                variant="OutlineBlack"
                hover={true}
                hoverclass="bg-black-900"
                onClick={(e) => { setIsAddMoney(false); }}
              >
                {t("cancel")}
              </Button>
            </div>
          ) : null}
        */}

        {/*
          ── COMMENTED: old step-2 amount summary row ──
          {paymentData?.step == 2 ? (
            <div className="flex flex-col gap-4 items-center justify-start w-full mb-[0px]">
              <div className="flex flex-row md:gap-5 items-center justify-center w-full">
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className="text-base text-black-900 font-nunitomedium">
                    {t("addMoneyToWallet")}
                  </Text>
                  <Text className="text-black-900 text-sm font-nunitoregular w-[80%] xs:w-full">
                    {t("sar")} {CUSTOM.setPrice(paymentData?.amount)}
                  </Text>
                </div>
                <Button
                  className="w-auto mx-auto px-3 py-1.5 text-sm"
                  size="sm"
                  variant="OutlineBlack"
                  hover={true}
                  hoverclass="bg-black-900"
                  onClick={(e) => { setPaymentData({ ...paymentData, step: 1 }); }}
                >
                  {t("change")}
                </Button>
              </div>
            </div>
          ) : null}
        */}
      </div>
    </>
  );
};

export default Account;